import React, { useState, useEffect, useRef } from 'react';

const MilestoneCard = ({ number, suffix, title, description, delay }) => {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef(null);
  const observerRef = useRef(null);

  useEffect(() => {
    // Store the current ref value in a variable
    const currentCard = cardRef.current;
    
    observerRef.current = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (currentCard) {
      observerRef.current.observe(currentCard);
    }

    return () => {
      if (observerRef.current && currentCard) {
        observerRef.current.unobserve(currentCard);
      }
    };
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    const duration = 2000;
    const steps = 60;
    const increment = number / steps;
    let current = 0;

    const timer = setInterval(() => {
      current += increment;
      if (current >= number) {
        setCount(number);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, duration / steps);

    return () => clearInterval(timer);
  }, [isVisible, number]);

  return (
    <div ref={cardRef} className="flex flex-col">
      <div className="text-5xl md:text-6xl lg:text-7xl text-[#FDA729] mb-8">
        {count}
        {suffix}
      </div>
      <h3 className="text-xl md:text-2xl text-white mb-4">
        {title}
      </h3>
      <p className="text-gray-300 text-sm md:text-base leading-relaxed">
        {description}
      </p>
    </div>
  );
};

export default function WorkMilestones({ milestones }) {
  return (
    <div className="py-16">
      <h1 className="text-4xl md:text-5xl lg:text-6xl text-white mb-16">
        Our Work Milestones
      </h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 lg:gap-16">
        {milestones.map((milestone, index) => (
          <MilestoneCard
            key={index}
            number={milestone.number}
            suffix={milestone.suffix}
            title={milestone.title}
            description={milestone.description}
            delay={index * 200}
          />
        ))}
      </div>
    </div>
  );
}